import React, { ReactElement, useState } from 'react';
import { makeStyles, createStyles, Theme, Collapse } from '@material-ui/core';
import DefaultCard from '../DefaultCard';
import { H4Text } from '../../TextVariants';
import CustomCheckbox from '../CustomCheckbox/CustomCheckbox';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexFlow: 'column',
    },
    disclaimerTitle: {
      fontWeight: 'bold',
      margin: theme.spacing(2, 0),
    },
    checkArea: {
      display: 'flex',
      alignItems: 'flex-start',
      '&:hover': {
        cursor: 'pointer',
      },
    },
  }),
);

interface Props {
  title?: string;
  body?: string;
  defaultValue?: boolean;
  onChange?: (val: boolean) => void;
  checkBoxId?: string;
  disclaimerId?: string;
  isDisplayedTitleInspection?: boolean;
}

export const defaultTitle = 'Declaración de veracidad';
export const defaultBody = `Declaro y Certifico bajo gravedad de juramento que la información declarada, 
proveída y/o escrita es real, exacta, correcta y que no he omitido ningún hecho, circunstancia, dato o 
información relevante que pudiera incidir en la evaluación del riesgo por parte de ASSA Compañía de Seguros.`;

export default function Signature({
  title = defaultTitle,
  body = defaultBody,
  defaultValue,
  onChange,
  checkBoxId,
  disclaimerId,
  isDisplayedTitleInspection = true,
}: Props): ReactElement {
  const classes = useStyles();
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  function handleClick(): void {
    setShowDisclaimer((val) => !val);
  }

  function handleKeyPress(e: React.KeyboardEvent<HTMLSpanElement>): void {
    if (e.key === 'Enter') {
      setShowDisclaimer(true);
    }
  }

  function handleOnchange(): void {
    onChange(!defaultValue);
  }

  return (
    <DefaultCard>
      <div className={classes.root}>
        <div className={classes.checkArea}>
          <CustomCheckbox
            id={checkBoxId}
            color="primary"
            checked={defaultValue}
            onChange={(e): void => onChange(e.target.checked)}
            data-testid="checkbox"
          />
          <div>
            {/* The requirement is that all the label except the link should trigger the checkbox */}
            <H4Text
              display="inline"
              onClick={handleOnchange}
              data-testid="label-1"
            >
              He leído y estoy de acuerdo con la{' '}
            </H4Text>
            <H4Text display="inline">
              <span
                role="button"
                id={disclaimerId}
                tabIndex={0}
                onClick={handleClick}
                onKeyPress={handleKeyPress}
                data-testid="disclaimer-link"
              >
                <u>
                  declaración de veracidad{!isDisplayedTitleInspection && '.'}
                </u>
              </span>{' '}
            </H4Text>
            {isDisplayedTitleInspection && (
              <H4Text
                display="inline"
                onClick={handleOnchange}
                data-testid="label-2"
              >
                en esta inspección.
              </H4Text>
            )}
          </div>
        </div>
      </div>
      <Collapse in={showDisclaimer} data-testid="disclaimer-area">
        <H4Text
          data-testid="disclaimer-title"
          className={classes.disclaimerTitle}
        >
          {title}
        </H4Text>
        <H4Text data-testid="disclaimer-body">{body}</H4Text>
      </Collapse>
    </DefaultCard>
  );
}
